<div class="flex flex-col relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h3 cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" mat-dialog-title>
		@if (existingObject()) {
			{{ t('billing.parameterValue.change' + flatrateExemptionService.selectedType()) }}
		} @else {
			{{ t('billing.parameterValue.new' + flatrateExemptionService.selectedType()) }}
		}
	</h3>
	<mat-dialog-content [formGroup]="flatrateExemptionFg" class="flex flex-col overflow-hidden gap-4 pt-8">
		@if (!finishedLoading()) {
			<div @fadeInUp class="flex flex-row justify-center">
				<mat-spinner color="primary"></mat-spinner>
			</div>
		} @else {
			<mat-form-field appearance="outline" class="w-[15rem] pt-8">
				<mat-label>{{ t('billing.selectedTu') }}</mat-label>
				<mat-select formControlName="tenantUnit" name="type" required>
					@for (currentTenantunit of tenantUnits(); track currentTenantunit) {
						<mat-option [value]="currentTenantunit">{{ currentTenantunit.number }} / {{ currentTenantunit.subNumber }}</mat-option>
					}
				</mat-select>
				<mat-error>
					{{ t('common.requiredField') }}
				</mat-error>
			</mat-form-field>

			<div class="flex flex-row items-start justify-between">
				<mat-form-field appearance="outline" class="w-[15rem]">
					<mat-label>{{ t('tenantunitDetails.details.validFrom') }}</mat-label>
					<input formControlName="validFrom" [matDatepicker]="dpFrom" [max]="toMaxDate" [min]="toMinDate" matInput required />
					<mat-error>
						{{ t(flatrateExemptionFg.errors?.message) }}
					</mat-error>
					<div matSuffix class="flex items-center">
						@if (flatrateExemptionFg.get('validFrom')?.value) {
							<mat-datepicker-toggle>
								<mat-icon matDatepickerToggleIcon (click)="flatrateExemptionFg.get('validFrom').setValue(null)">clear</mat-icon>
							</mat-datepicker-toggle>
						}
						<mat-datepicker-toggle [for]="dpFrom" matSuffix></mat-datepicker-toggle>
					</div>
					<mat-datepicker #dpFrom></mat-datepicker>
				</mat-form-field>

				<mat-form-field appearance="outline" class="w-[15rem]">
					<mat-label>{{ t('tenantunitDetails.details.validTo') }}</mat-label>
					<input formControlName="validTo" [matDatepicker]="dpTo" [max]="toMaxDate" [min]="toMinDate" matInput required />
					<mat-error>
						{{ t(flatrateExemptionFg.errors?.message) }}
					</mat-error>
					<div matSuffix class="flex items-center">
						@if (flatrateExemptionFg.get('validTo')?.value) {
							<mat-datepicker-toggle>
								<mat-icon matDatepickerToggleIcon (click)="flatrateExemptionFg.get('validTo').setValue(null)">clear</mat-icon>
							</mat-datepicker-toggle>
						}
						<mat-datepicker-toggle [for]="dpTo" matSuffix></mat-datepicker-toggle>
					</div>
					<mat-datepicker #dpTo></mat-datepicker>
				</mat-form-field>
			</div>

			@if (this.flatrateExemptionService.selectedType() === 'FLATRATE') {
				<mat-form-field appearance="outline" class="w-full">
					<mat-label>{{ t('common.value') }}</mat-label>
					<input matInput inputmode="decimal" araDecimalFormat max="100" formControlName="value" placeholder="{{ t('common.number') }}" />
					<span matSuffix class="text-xl">€&nbsp;</span>
					<mat-error>{{ t('common.formInvalid') }}</mat-error>
				</mat-form-field>
			}
		}
	</mat-dialog-content>
	<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
		<button (click)="close(true)" [disabled]="!flatrateExemptionFg.valid" color="primary" mat-raised-button type="submit">
			<mat-icon>check</mat-icon>
			@if (!layoutService.isMobile()) {
				{{ t('common.apply') }}
			}
		</button>
	</mat-dialog-actions>
</div>
